import { CAARepository } from '../repositories/CAARepository'

export function ListMonthCAAReport(caaRepositoryAdapter: CAARepository) {
  return async function ({
    patientId,
    month,
    year
  }: {
    patientId: string
    month: string
    year: string
  }) {
    return await caaRepositoryAdapter.listMonthCAAReport(patientId, month, year)
  }
}
